var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c(
        "v-col",
        { staticClass: "ma-0 pa-2 pt-4", attrs: { cols: "12" } },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-0 mb-3",
              attrs: { cols: "12", align: "center" },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "1.1rem",
                    "font-weight": "bold",
                    "margin-bottom": "1rem",
                  },
                },
                [_vm._v(_vm._s("Device Performance"))]
              ),
              _c(
                "v-btn",
                {
                  attrs: { width: "100%", height: "2.5rem", id: "blue_btn" },
                  on: { click: _vm.refreshPerformance },
                },
                [_vm._v(" " + _vm._s("refresh") + " ")]
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 mt-4", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0" },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-4 mb-4",
                          staticStyle: {
                            "background-color": "#1E1E1E",
                            border: "1px solid #4A4A4A",
                          },
                          attrs: { dark: "" },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "pa-0 mb-3",
                              staticStyle: {
                                color: "white",
                                "font-size": "1rem",
                              },
                            },
                            [_vm._v(" " + _vm._s("Hardware Concurrency") + " ")]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0",
                              staticStyle: {
                                color: "white",
                                "font-size": "1.1rem",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.hardwareConcurrency) +
                                  " " +
                                  _vm._s("cores") +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mt-2",
                              staticStyle: {
                                color: "#8E8E8E",
                                "font-size": "0.8rem",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s("Logical CPU core count") + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 mt-4", attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0" },
                [
                  _c(
                    "v-col",
                    { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-4 mb-4",
                          staticStyle: {
                            "background-color": "#1E1E1E",
                            border: "1px solid #4A4A4A",
                          },
                          attrs: { dark: "" },
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "pa-0 mb-3",
                              staticStyle: {
                                color: "white",
                                "font-size": "1rem",
                              },
                            },
                            [_vm._v(" " + _vm._s("VideoJS VHS") + " ")]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0",
                              staticStyle: {
                                color: "white",
                                "font-size": "1.1rem",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.recentVhsBandwidth) +
                                  " " +
                                  _vm._s("Mbps") +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mt-2",
                              staticStyle: {
                                color: "#8E8E8E",
                                "font-size": "0.8rem",
                              },
                            },
                            [_vm._v(" " + _vm._s("recent vhs bandwidth") + " ")]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0",
                              staticStyle: {
                                color: "white",
                                "font-size": "1.1rem",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.recentVhsThroughput) +
                                  " " +
                                  _vm._s("Mbps") +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mt-2",
                              staticStyle: {
                                color: "#8E8E8E",
                                "font-size": "0.8rem",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s("recent vhs throughput") + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 mt-4", attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-4",
                  staticStyle: {
                    "background-color": "#1E1E1E",
                    border: "1px solid #4A4A4A",
                  },
                  attrs: { dark: "" },
                },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "pa-0 mb-4",
                      staticStyle: { color: "white", "font-size": "1rem" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s("Network connection information") + " "
                      ),
                    ]
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-2",
                              staticStyle: {
                                color: "#8E8E8E",
                                "font-size": "0.85rem",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s("Connection speed grade") + " "
                              ),
                            ]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-4",
                              staticStyle: {
                                color: "white",
                                "font-size": "1rem",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.effectiveType || "N/A") + " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-2",
                              staticStyle: {
                                color: "#8E8E8E",
                                "font-size": "0.85rem",
                              },
                            },
                            [_vm._v(" " + _vm._s("Download speed") + " ")]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-4",
                              staticStyle: {
                                color: "white",
                                "font-size": "1rem",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.downlink
                                      ? _vm.downlink + " Mbps"
                                      : "N/A"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-2",
                              staticStyle: {
                                color: "#8E8E8E",
                                "font-size": "0.85rem",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s("Round-trip time (RTT)") + " "
                              ),
                            ]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-4",
                              staticStyle: {
                                color: "white",
                                "font-size": "1rem",
                                "font-weight": "bold",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.rtt ? _vm.rtt + " ms" : "N/A") +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0 mt-4", attrs: { cols: "12" } },
            [
              _c(
                "v-card",
                {
                  staticClass: "pa-4",
                  staticStyle: {
                    "background-color": "#1E1E1E",
                    border: "1px solid #4A4A4A",
                  },
                  attrs: { dark: "" },
                },
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass: "pa-0 mb-4",
                      staticStyle: { color: "white", "font-size": "1rem" },
                    },
                    [_vm._v(" " + _vm._s("Additional information") + " ")]
                  ),
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-0" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-2",
                              staticStyle: {
                                color: "#8E8E8E",
                                "font-size": "0.85rem",
                              },
                            },
                            [_vm._v(" " + _vm._s("User Agent (UA)") + " ")]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-4",
                              staticStyle: {
                                color: "white",
                                "font-size": "0.85rem",
                                "word-break": "break-all",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.userAgent) + " ")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0", attrs: { cols: "12" } },
                        [
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-2",
                              staticStyle: {
                                color: "#8E8E8E",
                                "font-size": "0.85rem",
                              },
                            },
                            [_vm._v(" " + _vm._s("Screen resolution") + " ")]
                          ),
                          _c(
                            "v-card-text",
                            {
                              staticClass: "pa-0 mb-4",
                              staticStyle: {
                                color: "white",
                                "font-size": "0.85rem",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.screenResolution) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }